/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
import $ from 'jquery';
import commonApiHelper from '@/scripts/commonApiHelper';
import store from '@/store';

export default {
    addYearAndLocation: function (parameters) {
        const s = store.state.selModel;
        parameters.push({ queryCode: 'years', value: s.years.asList.replaceAll(' ', '') });
        parameters.push({ queryCode: 'fips_codes', value: s.locations.ids.join(',') });
    },
    addYearAndLocationSmall: function (parameters) {
        const s = store.state.selModel;
        parameters.push({ queryCode: 'y', value: s.years.asList.replaceAll(' ', '') });
        parameters.push({ queryCode: 'l', value: s.locations.ids.join(',') });
    },
    addServiceParameters: function (parameters, program) {
        parameters.push({ queryCode: 'submit', value: 'Run+Report' });
        parameters.push({ queryCode: '_program', value: program });
        parameters.push({ queryCode: '_service', value: process.env.VUE_APP_SERVICE });
    },
    addVariableParameter: function (parameters, variable, parmName) {
        if (!variable.include)
            return;
        var value = commonApiHelper.getApiVariableName(variable.variable);
        if (value !== '')
            parameters.push({ queryCode: parmName, value: value });
    },
    getApiVariableName: function (variable) {
        //API uses _state as the variable for location
        if (!variable)
            return null;
        if (variable.variable === 'location')
            return '_state';
        else
            return variable.variable;

        //switch (variableSelection.type) {
        //  case 'year':
        //    return 'year';
        //  case 'location':
        //    return '_state';
        //  case 'variable':
        //    return variableSelection.variable.variable;
        //  default:
        //    return '';
        //}
    },
    toQueryString: function (parameters) {
        return parameters.map(p => '' + p.queryCode + '=' + p.value).join('&');
    },
    saveLogDataPut: function (logData) {
        $.ajax({
            url: '/BRFSSStates1.2.5/api/status/LogWeat',
            //url: 'http://localhost/BRFSSStates1.2.5/api/status/LogWeat',
            type: 'POST',
            data: JSON.stringify(logData),
            success: function (data) {
            },
            error: function (jqXHR) {
            }
        })
    },
    saveLogData: function (logData) {
        if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development')
            return;

        //sample1
        //const data = JSON.stringify(logData);
        //window.localStorage.setItem('arr', data);
        //sample 2
        const data = JSON.stringify(logData);
        const blob = new Blob([data], { type: 'text/plain' });
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');
        a.download = 'executionTime.json';
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
        e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
        //Sample 3
        //console.log(JSON.parse(window.localStorage.getItem('arr')))
        //$.ajax({
        //  url: '/BRFSSStates1.2.5/api/status/LogWeatGet?logData=abcddefwe',
        //  //url: 'http://localhost/BRFSSStates1.2.5/api/status/LogWeat',
        //  type: 'GET',
        //  //data: JSON.stringify(logData),
        //  success: function (data) {
        //  },
        //  error: function (jqXHR) {
        //  }
        //})
    }
}
